import { ChakraProps, chakra } from '@chakra-ui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { IconDefinition as SharpLightIconDef } from '@fortawesome/sharp-light-svg-icons';
import { IconDefinition as ThinIconDef } from '@fortawesome/pro-thin-svg-icons';
import { IconDefinition as CoreIconDef } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

export type FaIconProps = {
    icon: SharpLightIconDef | CoreIconDef | ThinIconDef;
} & ChakraProps & Omit<FontAwesomeIconProps, 'icon'>;

const FaIcon = React.forwardRef<SVGSVGElement, FaIconProps>(({ icon, size = '1x', ...props }: FaIconProps, ref) => {
    const ChakraIcon = chakra(FontAwesomeIcon);

    return (
        <ChakraIcon {...props} icon={icon as CoreIconDef} size={size} ref={ref} />
    );
});

export { FaIcon };
